import type { JSX } from "react";

export const Poster = (): JSX.Element => (
  <div
    aria-hidden
    className="absolute inset-0 bg-cover bg-center blur-sm brightness-[0.6]"
    style={{ backgroundImage: "url(/posters/room-poster.webp)" }}
  />
);
